import { displayAppointmentForm as displayAppointment } from 'owa-calendar-reading-pane-store';

export function displayAppointmentForm(itemId: string) {
    displayAppointment(itemId);
}
